import React, {Component, useState} from 'react';
import { Button, Container, Row, Col, FormControl, FormLabel, Alert } from 'react-bootstrap';
import ClientService from "./services/client.service";
import { Navigate } from 'react-router-dom';
import { IoIosArrowBack } from "react-icons/io";

var newDate = new Date()
var gtDate = newDate.getDate().toString().padStart(2,'0') + '-' + (newDate.getMonth()+1).toString().padStart(2,'0') + '-' + newDate.getFullYear()

class NewClient extends Component {  

  constructor(props) {
    super(props);
    this.onChangeClientName = this.onChangeClientName.bind(this);
    this.onChangeContactPerson = this.onChangeContactPerson.bind(this);
    this.onChangeContactPhone = this.onChangeContactPhone.bind(this);
    this.onChangeContactEmail = this.onChangeContactEmail.bind(this);
    this.saveClient = this.saveClient.bind(this);
    this.retrieveClients = this.retrieveClients.bind(this);
    this.refreshList = this.refreshList.bind(this);    
    this.handleValidations = this.handleValidations.bind(this);
    this.goToClientsList = this.goToClientsList.bind(this);

    this.state = {
      id: null,
      clientname: "",
      contactperson: "",
      contactphone: "",
      contactemail: "",
      submitted: false,
      clients: [],
      currentClient: null,
      currentIndex: -1,  
      showerror: false,
      errmessage:'',   
      showsuccess: false,
      succmessage: ''
    };
  }

  goToClientsList() {
    window.location.assign('/clients');
  }

  handleValidations() {
    if (this.state.clientname.length==0 || this.state.contactperson.length==0) {
      this.setState({errmessage:'Fields can not be empty.'})
      this.setState({showerror:true})
      return;
    }
    if (this.state.contactemail) {
      if (!/\S+@\S+\.\S+/.test(this.state.contactemail)) {
        this.setState({errmessage:'Email is invalid.'})
        this.setState({showerror:true})
        return;
      }      
    }
    this.saveClient();
  } 

  retrieveClients() {
    ClientService.getAll()
      .then(response => {
        this.setState({
            suppliers: response.data
        });
        console.log(response.data);
      })
      .catch(e => {
        console.log(e);
      });
  }

  refreshList() {
    this.retrieveClients();
    this.setState({
        currentClient: null,
        currentIndex: -1
    });
  }

  onChangeClientName(e) {
    this.setState({
        clientname: e.target.value
    });
  }

  onChangeContactPerson(e) {
    this.setState({
        contactperson: e.target.value
    });
  }

  onChangeContactPhone(e) {
    this.setState({
        contactphone: e.target.value
    });
  }  

  onChangeContactEmail(e) {
    this.setState({
        contactemail: e.target.value
    });
  }   

  saveClient() {
    var data = {
        clientname: this.state.clientname,
        clientcontactperson: this.state.contactperson,
        clientcontactphone: this.state.contactphone,
        clientcontactemail: this.state.contactemail
    };

    ClientService.create(data)
      .then(response => {
        this.setState({
          // id: response.data.id,
          suppliername: response.data.suppliername,
          contactperson: response.data.clientcontactperson,
          contactphone: response.data.clientcontactphone,
          contactemail: response.data.clientcontactemail,
          submitted: true          
        });
        this.setState({errmessage:''});
        this.setState({showerror:false});
        this.setState({succmessage:'Client has been created. Redirecting to client list...'});
        this.setState({showsuccess:true});           
        this.refreshList();
        console.log(response.data);
      })
      .catch(e => {
        this.setState({errmessage:e.response?e.response.data.message:e.message})       
        this.setState({showerror:true})
        this.setState({succmessage:''})
        this.setState({showsuccess:false}) 
      });
  }

  render() {
    return (
      <>
      <Container style={{width:"80%"}}>
        <Row className='mb-2'>
          <FormLabel style={{fontSize:"0.8em",textAlign:"right"}}>Current Date: {gtDate}</FormLabel>
          <hr/>
          <h4 className='mb-4' style={{width: "100%", textAlign: "center", marginLeft: "0%", color: "green" }}>New Client</h4>
          <Col className='col-md-3' sm={8}>
            <FormLabel className='mb-2'>Client Name:</FormLabel>       
            <FormControl style={{maxWidth:"300px"}} type="text" name="clientname" id="clientname" onChange={this.onChangeClientName}></FormControl>
          </Col>

          <Col className='col-md-3' sm={8}>
            <FormLabel className='mb-2'>Contact Person:</FormLabel>       
            <FormControl style={{maxWidth:"300px"}} type="text" name="contactperson" id="contactperson" onChange={this.onChangeContactPerson}></FormControl>
          </Col>          

          <Col className='col-md-3' sm={8}>
            <FormLabel className='mb-2'>Phone:</FormLabel>       
            <FormControl style={{maxWidth:"300px"}} type="number" name="contactphone" id="contactphone" onChange={this.onChangeContactPhone}></FormControl>
          </Col>  

          <Col className='col-md-3' sm={8}>
            <FormLabel className='mb-2'>Email:</FormLabel>       
            <FormControl style={{maxWidth:"300px"}} type="text" name="contactemail" id="contactemail" onChange={this.onChangeContactEmail}></FormControl>
          </Col>  

        </Row>
        <hr/>
        <Row className='mb-2'>
          <Col className='col-md-3'>
            <Button id='saveItem' onClick={this.handleValidations}>Save Client</Button>            
            <Button className='m-2' id='backToClientsList' onClick={this.goToClientsList}><IoIosArrowBack/></Button>            
          </Col>
        </Row>  
        {this.state.showerror && (
          <Alert variant="danger" onClose={() => this.setState({showerror:false})} dismissible>
            <Alert.Heading>Error</Alert.Heading>
            <p>{this.state.errmessage}</p>
          </Alert>      
        )}
        {this.state.showsuccess && (
          <Alert variant="success" onClose={() => this.setState({showsuccess:false})} dismissible>
            <Alert.Heading>Done</Alert.Heading>
            <p>{this.state.succmessage}</p>
          </Alert>      
        )}     
        { this.state.submitted ? (<Navigate push to="/clients"/>) : null }                                     
      </Container>
      </>
    )      
  }
}

export default NewClient;